class CreateEmailEnquiryDto {
    public firstname: string;
    public lastname: string;
    public emailAddress: string;
    public message: string;
    public customerReference: string;
    public privacy: boolean;
}

export { CreateEmailEnquiryDto }